<template>
  <section class="index-box">


    <common-banner page-name="home"></common-banner>
    <!-- 业务需求 -->
    <!-- <home-form></home-form> -->

    <template v-for="(item, index) in navList">
      <!-- 关于我们 -->
      <div class="container marginBottom60" v-if="item.showChildPosition == 'index_content'">
        <section class="row  content-box-one ">
          <section class="col-md-6">
            <section class="content-item nav-head-info">
              <p class="nav-head-title">{{item.navigationTitleEn}}</p>
              <p class="sort-line"></p>
              <p class="nav-head-text">{{item.navigationTitle}}</p>

              <p class="nav-head-desc" id='contentItemDesc' v-if="item.navigationDesc">{{item.navigationDesc}}</p>
              <router-link class="more-button"
                            :to="{
                              name: 'content',
                              query: {
                                primaryKey: item.primaryKey,
                              }
                            }"><p style="margin-bottom: 0">MORE</p> <span>></span></router-link>
            </section>
          </section>
          <section class="col-md-6">
            <section class="content-item about-box">
              <template v-if="contentImgMap[item.primaryKey]" v-for="(content,ci) in contentImgMap[item.primaryKey]">
                <router-link :to="{
                                name: 'content',
                                query: {
                                  primaryKey: item.primaryKey,
                                  childNavKey: content.primaryKey
                                }
                              }">
                  <!-- 左图右文 -->
                  <section class="about-item about-item-one"  v-if="ci % 2 === 0">
                    <el-image :src="content.navigationImgUrl" lazy></el-image>

                    <section class="about-item-main">

                        <section class="nav-title">{{content.navigationName}}</section>
                        <section class="nav-desc" id='itemDesc'>{{content.navigationDesc}}</section>
                    </section>
                  </section>
                   <!-- 右图左文 -->
                  <section class="about-item about-item-two"  v-if="ci % 2 != 0">

                    <section class="about-item-main">

                        <section class="nav-title">{{content.navigationName}}</section>
                        <section class="nav-desc" id='itemDesc'>{{content.navigationDesc}}</section>
                    </section>
                    <el-image :src="content.navigationImgUrl" lazy></el-image>
                  </section>
                </router-link>
              </template>
            </section>
          </section>
        </section>
      </div>

      <!-- 业务模块 -->
      <section class="marginBottom60"
        v-if="item.showChildPosition == 'index_card'"
        style="padding-right: 0">
        <home-business :navdata="item"></home-business>
      </section>

      <!-- 咨讯和联系我们 -->
      <div class="container" v-if="item.showChildPosition == 'index_swiper'">
        <!-- 咨讯 -->
        <section class="row content-box-two marginBottom60">
          <section class="content-main-box">
            <common-swiper :banner-list="informationContentList"
              :bg-color="swiperBgColor"
              :navdata="item"></common-swiper>
          </section>
        </section>
      </div>

      <!-- 咨讯和联系我们 -->
      <div class="container" v-if="item.showChildPosition == 'index_contact'">
        <!-- 联系我们 -->
        <section class="content-box-three marginBottom60">
          <section class="content-main-box">
            <p class="content-item-text">{{ item.navigationTitleEn }}</p>
            <p class="content-item-desc">{{ item.navigationName }}</p>
            <img class="ewm" :src="footerInfo.contactQrcodeUrl"/>
          </section>
        </section>
      </div>
    </template>
  </section>
</template>

<script>
import commonBanner from '@/components/commonBanner'
import commonSwiper from '@/components/commonSwiper'
import homeBusiness from '@/components/homeBusiness'
import homeForm from '@/components/homeForm'

import utils from '@/common/js/utils.js'
import { navContentList, navDetail, contactFooter, getNavList } from '../../api/index'

export default {
  name: 'index',
  data () {
    return {
      navList: [],
      informationContentList: [],
      aboutUsInfo: {},
      swiperBgColor: 'rgba(0, 0, 0, 0.8)',
      contentImgMap: {},
      footerInfo: {}
    }
  },
  components: {
    commonBanner,
    commonSwiper,
    homeBusiness,
    homeForm
  },
  methods: {
    async getNavContentList () {
      var param = {
        contentType: 'newsList',
        pageSize: 3,
        pageNumber: 1
      }
      var res = await navContentList(param)
      this.informationContentList = res.data
    },
    async getFooterInfo () {
      var res = await contactFooter({})
      this.footerInfo = res.data
    },
    async getNavList () {
      var res = await getNavList({})
      this.navList = res.data
      var that = this
      if (that.navList && that.navList.length) {
        that.navList.forEach((item) => {
          if (item.showChildPosition == 'index_content') {
            // 导航说明
            that.getChildNavList(item.primaryKey)
          }

          if (item.showChildPosition == 'index_swiper') {
            // 咨询内容
            that.getNavContentList()
          }
        })
      }

    },
    async getChildNavList (primaryKey) {
      var res = await getNavList({
        navigationParent: primaryKey
      })

      let contentImgMap = {}
      contentImgMap[primaryKey] = res.data
      this.contentImgMap = Object.assign(this.contentImgMap, contentImgMap)
      console.log(this.contentImgMap)
    }
  },
  mounted(){
    this.getNavList()
    this.getFooterInfo()
  },
}
</script>

<style lang="scss">
.index-box {
  width: 100%;
  background: #fff;
  overflow: hidden;
  .marginBottom60 {
    margin-bottom: 60px!important;
  }
  .content-item {

    color: #333;
  }
  .nav-head-info {
    .nav-head-title {
      font-size: 36px;
    }

    .sort-line {
      margin-top: 30px;
      width: 50px;
      height: 1px;
      background: #B1CECC;
    }

    .nav-head-text {
      margin-top: 25px;
      font-size: 24px;
    }

    .nav-head-desc {
      margin-top: 35px;
      font-size: 14px;
      color: #757575;
      line-height: 24px;
      height: 148px;
      overflow: hidden;
    }
  }
  .content-box-one {
    margin-top: 60px;
    .about-box {
      a {
        text-decoration: none;
      }
      .about-item {
        display: flex;
        align-items: center;
        /*width: 570px;*/
        height: 212px;
        .el-image {
          width: 50%;
          height: 100%;
        }
        .about-item-main {
          width: 50%;
          height: 100%;
          padding: 0 20px;
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .nav-title {
            font-size: 24px;
            font-weight: bold;
          }
          .nav-desc {
            margin-top: 15px;
            font-size: 16px;
            line-height: 25px;
            word-break: break-all;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }
      }
      .about-item-one {
        background: #B1CECC;
      }
      .about-item-two {
        background: #041b33;
      }
    }
    .col-md-6 {
      padding: 0;
    }
  }

  .more-button {
    margin-top: 50px;
    width: 122px;
    height: 43px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #B1CECC;
    font-size: 15px;
    color: #fff;

    span {
      display: inline-block;
      margin-top: -3px;
      margin-left: 10px;
    }
  }

  .content-box-two {
    background: #B1CECC;
    position: relative;
    height: 480px;
    margin: 0 auto;

    .content-main-box {
      width: 100%;
      height: 100%;
      /*position: absolute;*/
      /*top: -200px;*/
      /*left: 50%;*/
      /*transform: translateX(-50%);*/
      box-shadow: 2px 4px 8px rgba(132, 26, 30, 1);
    }

    .link-text {
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: right;
      position: absolute;
      bottom: 60px;
      right: 0;
      color: #fff;
      font-size: 22px;
    }
  }

  .content-box-three {
    /*height: 485px;*/
    display: flex;
    align-items: center;
    justify-content: center;

    .content-main-box {
      text-align: center;

      .content-item-text {
        font-size: 36px;
        color: #B1CECC;
      }

      .content-item-desc {
        font-size: 25px;
        color: #333;
        margin-top: 25px;
      }

      .ewm {
        margin-top: 20px;
        width: 162px;
        height: 162px;
      }
    }
  }
}
  @media screen and (max-width: 768px) {
    .content-box-one {
      .about-box {
        margin-top: 15px;
      }
    }
  }
</style>
